import { downloadDataUrl } from '@/lib/instagramPost'
import {Download, X} from 'lucide-react'

interface InstagramPostModalProps {
  previewUrl: string
  title: string
  filename: string
  onClose: () => void
}

function InstagramPostModal({ previewUrl, title, filename, onClose }: InstagramPostModalProps) {
  const save = () => {
    downloadDataUrl(previewUrl, filename)
  }

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-slate-950/70 p-4" role="dialog" aria-modal="true" aria-label="Post para Instagram">
      <div className="w-full max-w-md overflow-hidden rounded-3xl bg-white text-slate-800 shadow-2xl">
        <div className="flex items-center justify-between border-b border-slate-100 px-4 py-3">
          <div>
            <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-[#2a63e8]">Instagram</p>
            <h3 className="font-display text-lg font-black leading-tight text-[#12307a]">Post pronto para descarregar</h3>
          </div>
          <button type="button" onClick={onClose} className="grid h-9 w-9 place-items-center rounded-full bg-slate-100 text-slate-600" aria-label="Fechar">
            <X size={18} />
          </button>
        </div>
        <div className="p-4">
          <img src={previewUrl} alt={`Post de ${title}`} className="mx-auto w-full max-w-[320px] rounded-2xl border border-slate-200 object-cover shadow-sm" />
          <p className="mt-3 text-center text-xs text-slate-500">Sem o botão Leia +. Pronto para publicar no feed.</p>
          <button
            type="button"
            onClick={save}
            className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#0b2ea8] py-3 text-sm font-bold text-white"
          >
            <Download size={16} /> Descarregar PNG
          </button>
        </div>
      </div>
    </div>
  )
}

export default InstagramPostModal
